import React, { useState } from 'react'
import * as classes from './CorporateGovernance.module.scss'
import cn from 'classnames'
import IconRight from '../../icons/IconRight'

function Item({ item, imageSize, lang, location, getItemLink, moreText, lessText }) {
    const [isExpanded, setIsExpanded] = useState(false)
    const filesToShow = isExpanded ? item.files.length : 5
    const hasMoreFiles = item.files && item.files.length > 5

    return (
        <div className={cn(classes.Item, { [classes.LangHY]: lang === 'hy' })}>
            <div className={classes.ItemWrapper}>
                {item.photo && (item.photo[imageSize] || item.photo[1440]) ? (
                    <div
                        className={classes.ItemImage}
                        style={{
                            backgroundImage: `url(${item.photo[imageSize] ? item.photo[imageSize] : item.photo[1440]})`
                        }}
                    />
                ) : null}

                <div className={classes.ItemContent}>
                    {item.title && (
                        <h3
                            className={classes.ItemTitle}
                            dangerouslySetInnerHTML={{ __html: item.title }}
                        />
                    )}

                    {item.desc && (
                        <p
                            className={classes.ItemDesc}
                            dangerouslySetInnerHTML={{ __html: item.desc }}
                        />
                    )}

                    {item.files && item.files.length > 0 && (
                        <div className={classes.FilesSection}>
                            {item.files.slice(0, filesToShow).map((file, fileIndex) => (
                                file?.name && file?.file?.url && (
                                    <a
                                        key={fileIndex}
                                        href={file.file.url}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        className={classes.FileLink}
                                    >
                                        {file.name}
                                    </a>
                                )
                            ))}

                            {hasMoreFiles && (
                                <button
                                    className={classes.MoreLessBtn}
                                    onClick={() => setIsExpanded(!isExpanded)}
                                    dangerouslySetInnerHTML={{ __html: isExpanded ? lessText : moreText }}
                                >
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Item

